import { render } from "./BudgetImport.vue?vue&type=template&id=60604f0b&scoped=true"
import script from "./BudgetImport.vue?vue&type=script&lang=js"
export * from "./BudgetImport.vue?vue&type=script&lang=js"

import "./BudgetImport.vue?vue&type=style&index=0&id=60604f0b&scoped=true&lang=css"
import "./BudgetImport.vue?vue&type=style&index=1&id=60604f0b&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60604f0b"]])

export default __exports__